import {
  EXTENDED_WARRANTY_2YEAR_SKU,
  EXTENDED_WARRANTY_3YEAR_SKU,
} from '../_consts';
import WarrantySelection from '../_steps/enums/WarrantySelection';

export default function getExtendedWarrantySku(
  selection: WarrantySelection | undefined,
): string | null {
  switch (selection) {
    case WarrantySelection.TwoYear:
      return EXTENDED_WARRANTY_2YEAR_SKU;
    case WarrantySelection.ThreeYear:
      return EXTENDED_WARRANTY_3YEAR_SKU;
    default:
      return null;
  }
}
